import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";

const hotTags = [
  { label: "演唱会后台", slug: "yule" },
  { label: "直播名场面", slug: "wanghong" },
  { label: "片场路透", slug: "yingshi" },
  { label: "赛事现场", slug: "dianjing" },
  { label: "发布会截图", slug: "shehui" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category?q=${encodeURIComponent(q)}` : "/category");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20entertainment%20atmosphere%20with%20soft%20amber%20and%20crimson%20light%20streaks%20across%20a%20dark%20stage%2C%20blurred%20bokeh%20lights%2C%20cinematic%20wide%20composition%2C%20elegant%20editorial%20photography%2C%20no%20readable%20text%2C%20no%20people&width=1800&height=1000&seq=hero-gua-main&orientation=landscape"
          alt="瓜田前线 网曝吃瓜视觉合集首屏氛围图"
          title="瓜田前线 - 网曝吃瓜视觉合集"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-20 md:py-32 flex flex-col items-center text-center">
        <p className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm text-xs md:text-sm text-background-100 font-label animate-fade-in">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></span>
          视频 · 图片 · 截图 · 实拍画面，全网瓜料一次看全
        </p>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-bold text-background-50 tracking-wide animate-fade-up">
          瓜田前线
        </h1>
        <p className="mt-4 text-lg md:text-2xl font-heading text-accent-300 tracking-wide animate-fade-up">
          网曝吃瓜视觉合集
        </p>
        <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-200 animate-fade-up">
          聚合网曝吃瓜视频、吃瓜图片、聊天截图与实拍现场画面，覆盖娱乐爆料、网红动态、影视综艺与电竞赛事。
          用最短时间，看清每一个热门事件的来龙去脉。
        </p>

        <form onSubmit={handleSearch} className="mt-9 w-full max-w-2xl animate-fade-up">
          <div className="flex flex-col sm:flex-row gap-2.5 p-2 rounded-2xl bg-background-50/10 border border-background-50/25 backdrop-blur-md">
            <div className="flex items-center gap-2 flex-1 min-w-0 px-3">
              <i className="ri-search-line text-background-200 text-lg" aria-hidden="true"></i>
              <label htmlFor="hero-search" className="sr-only">
                搜索瓜料关键词
              </label>
              <input
                id="hero-search"
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="输入关键词，例如 演唱会 / 直播 / 片场"
                className="w-full bg-transparent border-0 text-sm text-background-50 placeholder:text-background-300 py-3 focus:outline-none"
              />
            </div>
            <button
              type="submit"
              className="px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              搜索瓜料
            </button>
          </div>
        </form>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5">
          <span className="text-xs text-background-300">热搜标签</span>
          {hotTags.map((tag) => (
            <Link
              key={tag.label}
              to={`/category/${tag.slug}`}
              className="px-3.5 py-1.5 rounded-full border border-background-50/25 text-xs text-background-100 hover:bg-background-50/15 hover:border-accent-400 transition-colors"
            >
              # {tag.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}